//log in

import { agentLogin, agentService, loginAdmin, getCustomerInformation, getDashBoardHeaders } from "./agent.service";
import Logger from "./logger.service";
import { store } from "../context/store";
import { handleDispositionEnable, handleMultiDisposition, handleSipLoginFail, loading, login, logout, minimizeCall, setAdminToken, setAgentState, setAleadyLoggedIn, setAudioSettingSkinIds, setBlendedModeActiveDialer, setChatOnCall, setDispositionReqbody, setDispositionValues, setHealthCheckTime, setIsExceptionState, setLoginViaAppData, setLogoutTimer, setMfaCheck, setNotificationData, setOTPVerify, setRefreshToken, setShowMinimizedCallControls, setTemplate, setWhatsAppSavedReplys, setWhatsAppTemplates } from "../context/toolbarSlice";
import { AGENT_STATE, MODES, WEB_EVENTS } from "../constants";
import { changeAgentMode, handleAgentRelease, handleCallAnswered, handleCallEndData, handleDropCall, handleNewCall, handleNewIncommingCall, handleToolbarRelease, releaseAgent } from "./webEventHandlers";
import { setCallControlsActions, setCurrentLocationTimeAndRescheduleTime, setIsCallAttended, setIsComponentOnCall, callEndActions, setIsCallIncomming, setIsCallEnded, setScreenpopURL, pauseAfterCall, pauseToggle } from "../context/callSlice";
import LocalStorageService from "./localstorage.service";
import MessageService from "./message.service"
import sipService from "./sip.service";
import { showErrorNotification, showSuccessNotification, showWarningNotification } from "../components/common/NotiService";
import { clearSession, closeAllPreviewScreenpops, countdownTimer, findPauseReason, generateUniqSessionId, getAgentData, getAvailableModes, getDefaultMode, getParam, getPreviewNumber, handleScreenRecording, isSettingEnabled, removeScreenpopFromStorage, resetPreviewNumber, setLoginData } from "./util";
import WSocketService from "./websocket.service";
import { setAgentStateDuration, setAutoUpdateAgentState, setWrapUpTime, setReUpdateTimer, setTimeAfterPauseReason, setPauseReason } from "../context/timerSlice";
import dayjs from "dayjs";
import { registerServiceWorker } from "./notificationHandler";
import { handleChatAcceptStatus, pauseAfterSession, showPauseAfterSessionTime } from "../context/digitalSlice";
import HttpService from "./http.service";
import { aToolbar } from "../toolbar";
import { removeTab } from "../context/dashboardSlice";
import { app } from "../config";
import { goToLogin } from "./navigation";

let socketConnectionIntervel = null;
let setLoginLoading;
let isReloadInProgress = false;
let isReConnectInProgress = false;
export async function handleAgentLogin(data, loginLoading) {
    try {
        setLoginLoading = loginLoading
        if (data.sso) {
            data.pin = ''
        }
        let responseData = await agentLogin(data);
        if (responseData.status === 'error') {
            onAlreadyLoggedIn(responseData)
            setLoginLoading(false)
            return "Login fail"
        } else if (responseData.loggedIn === "true") {
            Logger.info('Login as ' + data.agentid);
            checkMFAEnabled(responseData);
            aToolbar !== undefined && aToolbar.trigger("login");
            LocalStorageService.removeItem('sameLoggedInAgentDetails');
            return "Login success"
        }
        else if (responseData.status === "mobileLoginNotAllowed") {
            setLoginLoading(false);
            showWarningNotification(responseData?.message);
        }
        else if (responseData.status === "redirect" && responseData.redirectURL !== "") {
            window.location.href = responseData.redirectURL;
            return "";
        } else if (responseData.status === "sso_redirect" && responseData?.url !== "" && responseData?.ssid !== "") {
            let url = new URL(app.urls["adminAuthUrl"]);
            let redirectUrl = new URL(url.origin + responseData.url);
            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete("error");
            currentUrl.searchParams.delete("message");
            currentUrl.searchParams.delete("ssid");
            currentUrl.searchParams.delete("code");
            currentUrl.searchParams.delete("session_state");
            currentUrl.searchParams.delete("scope");
            redirectUrl.searchParams.set("RelayState", btoa(JSON.stringify({ provider: redirectUrl.pathname.split("/").pop(), ssid: responseData.ssid, url: currentUrl }) + `~${currentUrl}`));
            try {
                const features = "popup=yes,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=700";
                const inIframe = (() => { try { return window.self !== window.top; } catch { return true; } })();
                // Open SSO in a pop up if toolbar is loaded using Iframe
                if (inIframe) {
                    try {
                        if (window.__ssoPopup && !window.__ssoPopup.closed) {
                            window.__ssoPopup.location = redirectUrl.toString();
                            window.__ssoPopup.focus();
                        } else {
                            window.open(redirectUrl.toString(), "sso_login", features);
                        }
                    } catch (e) {
                        window.open(redirectUrl.toString(), "sso_login", features);
                    }
                } else {
                    window.location.href = redirectUrl.toString();
                }
            } catch (e) {
                console.log("Unable to set sso url to popup", e)
            }
            return;
        } else if (responseData?.loggedIn === "false" && responseData?.message === "sso not active" && responseData?.status === "success") {
            closeSSOPopUp()
            setLoginLoading(false);
            if (responseData?.message) {
                showWarningNotification("Please enable SSO configuration and try again.");
            }
            return "Login fail";
        } else {
            closeSSOPopUp()
            setLoginLoading(false)
            return "Login fail"
        }
    } catch (e) {
        closeSSOPopUp()
        Logger.log(JSON.stringify(e))
        setLoginLoading(false);
        return "Login fail"
    }
}

function closeSSOPopUp() {
    try {
        if (window.__ssoPopup && !window.__ssoPopup.closed) {
            window.__ssoPopup.close();
        }
    } catch { }
}

async function checkMFAEnabled(responseData) {
    setLoginData(responseData);
    store.dispatch(login(true));
    await handleMfaVerification();
}
async function handleMfaVerification() {
    store.dispatch(setMfaCheck(true));
    console.log("agent details stored");
}

export async function initateSetup(data) {
    WSocketService.initConnection('login');  // calling web socket service ..
    socketConnectionIntervel = setInterval(webSocketAuth, 1000);
    registerServiceWorker();//initiate service worker registration if available
}

const webSocketAuth = () => {
    Logger.log("webSocketAuth: Checking websocket connection")
    if (WSocketService.isSocketConnecting()) {
        Logger.log("webSocketAuth: Websocket still connecting")
    } else if (WSocketService.isSocketConnected()) {
        Logger.log("webSocketAuth: Websocket connected , clearing interval")
        clearInterval(socketConnectionIntervel);
        //for Mobile
        if (navigator.userAgent.includes('Android') || navigator.userAgent.includes('iPhone')) {
            LocalStorageService.setObject('loginDetails', store.getState().toolbar.loginDetails)
        }
    } else {
        if (WSocketService.isSocketClosed()) {
            setLoginLoading(false);
            clearInterval(socketConnectionIntervel);
            showWarningNotification('WebSocket not Connected');
            Logger.log("webSocketAuth: Websocket not connected, clearing interval")
        }
        setLoginLoading(false)
    }
}


export function onAlreadyLoggedIn(responseData) {
    try {
        const toggle = store.getState().toolbar.activeToggle;
        const activeToggle = toggle ? toggle : localStorage.getItem("activeToggle") ? localStorage.getItem("activeToggle") : "sip";

        setLoginLoading(false)
        var alreadyLoggedIn = responseData.hasOwnProperty('alreadyLoggedInMap');
        Logger.error(responseData.message)
        let alreadyLoggedIndetails = responseData.alreadyLoggedInMap
        LocalStorageService.setItem('sameLoggedInAgentDetails', JSON.stringify(alreadyLoggedIndetails))
        if (alreadyLoggedIn) {
            store.dispatch(setAleadyLoggedIn(true))
        } else {
            store.dispatch(setAleadyLoggedIn(false))
        }
        let messageToDisplay = responseData?.message;
        const regex = /(Error:)(.+?)( logged in with the number\(\d+\))$/;
        const match = messageToDisplay?.match(regex);

        if (match) {
            const errorPrefix = match[1];
            const agentId = match[2].trim();
            const suffix = match[3];
            const MAX_ID_LENGTH = 25;
            if (agentId?.length > MAX_ID_LENGTH) {
                const shortenedId = agentId.substring(0, MAX_ID_LENGTH) + '...';
                messageToDisplay = `${errorPrefix} ${shortenedId} ${suffix}`;
            }
        }
        if (activeToggle === "sip" && responseData.message.includes("SIP number is not assigned")) {
            store.dispatch(handleSipLoginFail(true));
        }
        else {
            showWarningNotification(messageToDisplay);
        }
    } catch (e) {
        console.log("Agent already logged in :", e)
    }
}

export const handleAgentLogout = async (data, agentLogoffByAdmin = false, useParams = true) => {
    try {
        var formData = new FormData();
        formData.append("action", 'logMeOut');
        formData.append("username", data.customer);
        formData.append("agentId", data.agentid);
        formData.append("who", 'agent');
        let loginRespData = await HttpService.post('logout', formData);
        const status = loginRespData.hasOwnProperty('data') ? loginRespData.data : null;
        if (status === 'Success:Logout success.') {
            closeAllPreviewScreenpops();
            aToolbar !== undefined && aToolbar.trigger("logout");
            window.parent.postMessage({ action: "logout", token: {} }, "*");
            store.dispatch(setAleadyLoggedIn(false));
            store.dispatch(logout())
            Logger.info('Logged out..you can login now');
            clearSession(useParams);
            store.dispatch(setLoginViaAppData({
                customer: null,
                agentid: null,
                phoneNumber: null,
                pin: null
            }))
        }
        else {
            showErrorNotification(status || 'Failed to Logout');
            Logger.error("Failed to logout:" + JSON.stringify(loginRespData))
        }
    } catch (e) {
        console.log("eror while force logout", e)
    }

}

export const handleAgentLogoffByAdmin = ({ navigateHome = () => { } }) => {
    try {
        aToolbar !== undefined && aToolbar.trigger("logout");
        window.parent.postMessage({ action: "logout", token: {} }, "*");
        Logger.info('Logged out..you can login now');
        clearSession(true);
        store.dispatch(setAleadyLoggedIn(false));
        store.dispatch(logout())
        store.dispatch(setLoginViaAppData({
            customer: null,
            agentid: null,
            phoneNumber: null,
            pin: null
        }))
        if (navigateHome && typeof navigateHome === "function") {
            navigateHome();
        }
    } catch (error) {
        console.error("Error while agent log off by admin", error)
    }
}

export function webSocketLoginAuth() {
    Logger.info('websocket auth started tbAgentLogin');

    Logger.info(store.getState()?.toolbar?.agent?.mode);
    generateUniqSessionId();
    agentService('tbAgentLogin', {
        params: store.getState()?.toolbar?.agent?.mode,
        reconnect: 'false',
    }).then((resp) => {
        let respKeys = Object.keys(resp);
        if (respKeys.includes('message') || respKeys.includes('status')) { // Failed case
            setLoginLoading(false)
            Logger.error('auth failed')
            showErrorNotification(resp.message || 'Authentication Failed')
            let message = resp.message || resp.status
            Logger.error(message)

        } else { // success case 
            store.dispatch(setOTPVerify(true));
            Logger.info("websocket auth successful")
            localStorage.setItem('isLoggedIn', true)
            localStorage.setItem('reconnect', false)
            sessionStorage.setItem('sessionReconnect', false)
            let smsTemplates = JSON.parse(resp.stemps)
            if (smsTemplates) {
                store.dispatch(setTemplate(smsTemplates));
            }
            store.dispatch(setHealthCheckTime(resp?.healthCheckTime))
            handleScreenRecording("login", "start");
            window.parent.postMessage({ action: "login", token: {} }, "*");
            changeAgentMode(getDefaultMode())
            if (respKeys?.includes('audioSettings') && resp?.audioSettings) {
                SaveAudioSettingsOnPageRefresh(resp);
            }

        }
    }
    ).catch(e => {
        console.log('auth failed', e)
        setLoginLoading(false)
        showErrorNotification('Authentication Failed')
    })
}
export const SaveAudioSettingsOnPageRefresh = (resp) => {
    const loginDetails = store.getState().toolbar.loginDetails;
    const SAVE_AUDIO_SETTINGS = isSettingEnabled('SAVE_AUDIO_SETTINGS');
    try {
        if (loginDetails && loginDetails.isSip && SAVE_AUDIO_SETTINGS) {
            const audioSettings = resp?.audioSettings;
            if (!audioSettings || Object.keys(audioSettings).length === 0) {
                console.warn('Audio settings not present in the reconnection response. Skipping update.');
                return;
            }
            store.dispatch(setAudioSettingSkinIds({
                type: 'ring_audio',
                id: audioSettings.ring_audio // audioSettings is guaranteed to exist here
            }));

            store.dispatch(setAudioSettingSkinIds({
                type: 'beep_audio',
                id: audioSettings.beep_audio
            }));

            store.dispatch(setAudioSettingSkinIds({
                type: 'call_audio',
                id: audioSettings.call_audio
            }));

            LocalStorageService.setItem('ring_audio', JSON.stringify(audioSettings.ring_audio));
            LocalStorageService.setItem('beep_audio', JSON.stringify(audioSettings.beep_audio));
            LocalStorageService.setItem('call_audio', JSON.stringify(audioSettings.call_audio));

        }
    } catch (error) {
        console.error('Failed to save audio settings on page refresh:', error);
    }
}
//refresh -> page reload
export async function handleReload(onSuccess, onFailure) {
    store.dispatch(loading(true));
    let mode = store.getState().toolbar.agent.mode;
    const showPauseTimeExceededLabel = store.getState().digital.showPauseTimeExceededLabel;
    let autoUpdateAgentState = LocalStorageService.getObject("agentCountDown");
    let answeredChats = store.getState().digital.answeredChats;
    let isComponentOnCall = store.getState().call.isComponentOnCall;
    const blendedModeActiveDialer = store.getState().toolbar.blendedModeActiveDialer;
    const previewDataAfterRefresh = store.getState().toolbar.previewCampaignNumberDetails;
    const campaignSelectedState = previewDataAfterRefresh?.campaignSelectedState || false;
    const selectedCampaingNumberDetails = previewDataAfterRefresh?.selectedCampaingNumberDetails || [];
    const selectedCampaignData = previewDataAfterRefresh?.selectedCampaignData || null;
    try {
        if (isReloadInProgress) {
            console.warn("handleReload is already in progress.");
            return;
        }
        isReloadInProgress = true;
        if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
            await resetPreviewNumber(selectedCampaingNumberDetails?.id, false);
        }
        await agentService("tbReconnect", {
            mode: mode.toUpperCase(),
            reconnect: true,
            event: 'refresh',
            ucid: store.getState()?.call?.callDetails?.ucid ? store.getState().call.callDetails.ucid : null
        }
        ).then((resp) => {
            if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
                getPreviewNumber(selectedCampaignData);
            }
            aToolbar !== undefined && aToolbar.trigger("init")
            showSuccessNotification('Application Connected Successfully');
            window.parent.postMessage({ action: "login", token: {} }, "*");
            if (!showPauseTimeExceededLabel) {
                if (resp.idleTime) { store.dispatch(setAgentStateDuration(resp.idleTime)) }
            }
            let value = Number(LocalStorageService.getItem("maxPauseTime"));
            if (value > 0) {
                store.dispatch(setTimeAfterPauseReason(LocalStorageService.getItem('pauseTimeCompleted')))
            }
            store.dispatch(loading(false));
            if (autoUpdateAgentState !== null && autoUpdateAgentState !== undefined) {
                store.dispatch(setAutoUpdateAgentState({ countDown: autoUpdateAgentState.countDown, altered: autoUpdateAgentState.altered }));
            }
            handleNotReadyTimeount()
            let respKeys = Object.keys(resp);
            let reloadSucceeded = false;
            if (respKeys.includes('status')) {
                if (resp.status === "Success") {
                    reloadSucceeded = true;
                    Logger.info("refresh:Application Connected Successfully")
                    if (!navigator.userAgent.includes('Android') && !navigator.userAgent.includes('iPhone')) {
                        LocalStorageService.removeItem('loginDetails');
                    }
                    LocalStorageService.removeItem('mode');
                    LocalStorageService.removeItem('isCallAttended');
                    if (respKeys?.includes('audioSettings') && resp?.audioSettings) {
                        SaveAudioSettingsOnPageRefresh(resp);
                    }
                }
                if (respKeys.includes('latestToken')) {
                    const latestToken = { ...JSON.parse(resp.latestToken), reconnect: false };
                    if (latestToken.type === 'toolbarLogout') {
                        clearSession(); // toolbarLogout
                    }
                    else {
                        changeAgentMode(resp.mode, { reconnect: 'true', latestToken });
                        handleActionsAfterReload(latestToken);  // reconnect
                        LocalStorageService.removeItem("state")
                        if ((resp.mode === 'CHAT' || resp.mode === 'BLENDED') && resp.latestToken) {
                            MessageService.handleReLoad()
                        }
                    }
                }
                let showMinimizedCall = LocalStorageService.getItem("showMinimizedCall")

                if ((mode === 'blended') && Object.keys(answeredChats).length > 0) {
                    if (showMinimizedCall === 'true' && !isComponentOnCall) {
                        store.dispatch(minimizeCall(true))
                        store.dispatch(setIsComponentOnCall(false));
                        store.dispatch(setIsCallAttended(false));
                        store.dispatch(handleChatAcceptStatus(true))
                    }
                }
                if ((mode === 'blended') && showMinimizedCall === 'true') {
                    store.dispatch(minimizeCall(false))
                    store.dispatch(setShowMinimizedCallControls(false));
                    store.dispatch(setIsComponentOnCall(true));
                    store.dispatch(setIsCallAttended(true));
                }
            } else {
                Logger.error('Refresh Un-successful');
                store.dispatch(loading(false));
                showErrorNotification('Refresh Un-successful');
                onFailure?.();
            }
            if (reloadSucceeded) onSuccess?.();
            isReloadInProgress = false;
        }).catch(e => {
            Logger.error('error Refresh', e);
            isReloadInProgress = false;
            store.dispatch(loading(false));
        })
    } catch (e) {
        Logger.error('error Refresh', e);
        isReloadInProgress = false;
        store.dispatch(loading(false));
    }
}

//reconnect - reconnect and refresh from toolbar

export async function handleReconnect(mode, onSuccess, onFailure) {
    store.dispatch(loading(true));
    const showPauseTimeExceededLabel = store.getState().digital.showPauseTimeExceededLabel;
    const blendedModeActiveDialer = store.getState().toolbar.blendedModeActiveDialer;
    const previewDataAfterRefresh = store.getState().toolbar.previewCampaignNumberDetails;
    const campaignSelectedState = previewDataAfterRefresh?.campaignSelectedState || false;
    const selectedCampaingNumberDetails = previewDataAfterRefresh?.selectedCampaingNumberDetails || [];
    const selectedCampaignData = previewDataAfterRefresh?.selectedCampaignData || null;
    let answeredChats = store.getState().digital.answeredChats;
    try {
        if (isReConnectInProgress) {
            console.warn("handleReconnect is already in progress.");
            return;
        }
        isReConnectInProgress = true;
        if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
            await resetPreviewNumber(selectedCampaingNumberDetails?.id, false);
        }
        if (Object.keys(answeredChats).length > 0 && (mode === "blended" || mode === "chat")) {
            LocalStorageService.setItem("isChatActive", store.getState().digital.isChatActive);
        }
        await agentService("tbReconnect", {
            mode: mode.toUpperCase() || MODES.INBOUND,
            reconnect: true,
            event: 'reconnect',
            ucid: store.getState()?.call?.callDetails?.ucid ? store.getState().call.callDetails.ucid : null

        }
        ).then((resp) => {
            store.dispatch(loading(false));
            if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
                getPreviewNumber(selectedCampaignData);
            }
            let respKeys = Object.keys(resp);
            let reconnectSucceeded = false;
            if (respKeys.includes('status')) {
                if (resp.status === "Success") {
                    reconnectSucceeded = true;
                    showSuccessNotification("Application Connected Successfully")
                    window.parent.postMessage({ action: "login", token: {} }, "*");
                    if (!showPauseTimeExceededLabel) {
                        if (resp.idleTime) { store.dispatch(setAgentStateDuration(resp.idleTime)) }
                    }
                    let value = Number(LocalStorageService.getItem("maxPauseTime"));
                    if (value > 0) {
                        store.dispatch(setTimeAfterPauseReason(LocalStorageService.getItem('pauseTimeCompleted')))
                    }
                    store.dispatch(setBlendedModeActiveDialer(LocalStorageService.getItem('blendedModeActiveDialer')))
                    let answeredChats = store.getState().digital.answeredChats;
                    let simplifiedAnsweredChats = {};
                    Object.keys(answeredChats).forEach(key => {
                        const chatCustSessionId = answeredChats[key].chatCustSessionId;
                        const count = answeredChats[key].count;
                        simplifiedAnsweredChats[chatCustSessionId] = { count };
                    });
                    localStorage.setItem('answeredChatDetailsForChatInactivity', JSON.stringify(simplifiedAnsweredChats))
                    if (respKeys.includes('latestToken')) {
                        const latestToken = { ...JSON.parse(resp.latestToken), reconnect: true };
                        if (latestToken?.type === 'toolbarLogout') {
                            clearSession(); // toolbarLogout
                        }
                        else {
                            changeAgentMode(resp.mode, { reconnect: 'true', latestToken });
                            handleActionsAfterReload(latestToken);
                            if ((resp.mode === 'CHAT' || resp.mode === 'BLENDED') && resp.latestToken) {
                                MessageService.handleReLoad()
                            }
                        }
                    }
                    if (respKeys?.includes('audioSettings') && resp?.audioSettings) {
                        SaveAudioSettingsOnPageRefresh(resp);
                    }
                    Logger.info("reconnect: Application Connected Successfully")
                }
            } else {
                Logger.error('Refresh Un-successful')
                store.dispatch(loading(false));
                showErrorNotification('Refresh Un-successful')
                onFailure?.();
            }
            if (reconnectSucceeded) onSuccess?.();
            isReConnectInProgress = false;
        }).catch(e => {
            Logger.error('error Refresh', e);
            store.dispatch(loading(false));
            isReConnectInProgress = false;
        })
    } catch (e) {
        Logger.error('error Refresh', e); store.dispatch(loading(false));
        isReConnectInProgress = false;
    }
}

function handleActionsAfterReload(refreshData) {
    const isExceptionState = store.getState().toolbar.isExceptionState; // used for Exception Calls Allowed per Agent exception
    let answeredChats = store.getState().digital.answeredChats;
    const MANUAL_CALL_RETRY = store.getState().toolbar.params.MANUAL_CALL_RETRY;

    aToolbar !== undefined && aToolbar.trigger("login");
    let value = Number(LocalStorageService.getItem("maxPauseTime"));
    if (value > 0) {
        store.dispatch(setTimeAfterPauseReason(LocalStorageService.getItem('pauseTimeCompleted')))
    }
    if (refreshData.type !== "dropCall" && isExceptionState) { // used for Exception Calls Allowed per Agent exception
        store.dispatch(setIsExceptionState(false));
    }
    switch (refreshData.type) {
        case WEB_EVENTS.newCall:
            if (!sipService.isSIPEnabled || refreshData.reconnect || MANUAL_CALL_RETRY === "true") {
                handleNewCall(refreshData);
                window.parent.postMessage({ action: "newCall", token: refreshData }, "*");
            }
            break;
        case WEB_EVENTS.agentCallAnswered:
            handleNewIncommingCall(refreshData, false);
            break;
        case WEB_EVENTS.busyAgent:
            if (!sipService.isSIPEnabled || refreshData.reconnect || MANUAL_CALL_RETRY === "true") {
                handleCallAnswered(refreshData);
                window.parent.postMessage({ action: "busyAgent", token: refreshData }, "*");
            }
            break;
        case WEB_EVENTS.agentRelease:
            const isSip = store.getState().toolbar.loginDetails.isSip;
            if (!Object.keys(answeredChats).length >= 1) {
                let time = getTimeDifference(refreshData.eventTime.split(" ")[1]);
                // handleAgentRelease resets the wrap-up counter to 0 on ACW entry,
                // so run it first and restore the elapsed time (time since the
                // release event) afterwards to resume the countdown on refresh.
                handleAgentRelease(refreshData);
                if (isSip && MANUAL_CALL_RETRY === "false" && app?.toolbarInstance === 'us') {
                    store.dispatch(setWrapUpTime(0));
                } else {
                    store.dispatch(setWrapUpTime(time));
                }
            }
            break;
        case WEB_EVENTS.callDetails:
            handleCallEndData(refreshData);
            break;
        case WEB_EVENTS.agentReleaseWOACW:
            handleDropCall({ type: "agentReleaseWOACW", ucid: refreshData.ucid, latestToken: refreshData });
            break;
        case WEB_EVENTS.dropCall:
            handleDropCall({ type: "agentReleaseWOACW", ucid: refreshData.ucid, latestToken: refreshData, isException: isExceptionState });
            break;
        case "toolbarPause":
            handleToolbarPause(refreshData);
            break;
        case "toolbarRelease":
            handleToolbarRelease()
            break;
        case "toolbarChangeState":
            handleExceptionState();
            break;
        case WEB_EVENTS.incomingConferenceCall:
            handleNewCall(refreshData);
            break;
        case WEB_EVENTS.conferenceStart:
            handleCallAnswered(refreshData);
            break;
        default: break;
    }

    if (store.getState().call.isComponentOnCall || store.getState().call.isCallIncomming) {
        store.dispatch(setAgentState(AGENT_STATE.READY));
    }

    if (store.getState().call.isCallAttended) {
        store.dispatch(setCallControlsActions(LocalStorageService.getObject('callControlActions')))
        LocalStorageService.removeItem('callControlActions');
    }

    store.dispatch(setNotificationData(LocalStorageService.getObject('notifications') !== null ? LocalStorageService.getObject('notifications') : []));
    store.dispatch(setReUpdateTimer(false))
    getCustomerInformation();
}
export function handleToolbarPause(refreshData) {
    console.log("latest token type toolbarPause");
    try {
        const pauseAfterSessionEnabled = store.getState().digital.pauseAfterSession;
        const pauseAfterCallStatus = store.getState().call.pauseAfterCallStatus;
        const AGENT_AUTO_RELEZ = store.getState()?.toolbar?.params?.AGENT_AUTO_RELEZ;
        let currentTime = new Date();
        let time = findPauseReason(decodeURIComponent(refreshData?.pauseReason));
        let tempPauseReason = {
            reason: decodeURIComponent(refreshData?.pauseReason),
            timeLimit: time || 0
        }
        store.dispatch(setPauseReason(tempPauseReason));
        let originalPauseDuration = tempPauseReason?.timeLimit ?? 0;
        if (isNaN(originalPauseDuration) || originalPauseDuration < 0) {
            console.error("Invalid pause duration:", originalPauseDuration);
            return;
        }
        let pauseTime = localStorage.getItem('pauseTime');
        let pauseDate = new Date(pauseTime);
        let pauseDuration = originalPauseDuration * 1000; // Convert to milliseconds
        let elapsedTime = currentTime - pauseDate;
        let remainingPauseTime = Math.max((pauseDuration - elapsedTime) / 1000, 0); // Convert to seconds and ensure non-negative
        let tempTime = (originalPauseDuration - Math.round((elapsedTime / 1000)))
        if (tempTime < 0 && time !== 0) {
            console.log("Pause time exceeded, moving agent to READY state.");
            if (AGENT_AUTO_RELEZ === "true" || AGENT_AUTO_RELEZ === true) {
                console.log("Pause time exceeded, checking setting:", AGENT_AUTO_RELEZ);
                releaseAgent();
            } else {
                console.log("Pause time exceeded, but auto-release is disabled:", AGENT_AUTO_RELEZ);
            }
        } else {
            LocalStorageService.setItem('toolbarPause', true);
            LocalStorageService.setItem('toolbarPauseTime', Math.round((elapsedTime / 1000)));
            let temp = structuredClone(tempPauseReason);
            temp.timeLimit = originalPauseDuration - Math.round(remainingPauseTime)

            if (pauseAfterSessionEnabled) {
                store.dispatch(pauseAfterSession({ type: false, reason: null }))
                store.dispatch(showPauseAfterSessionTime(true))
            }
            if (pauseAfterCallStatus) {
                store.dispatch(pauseAfterCall({ type: false, reason: null }));
                store.dispatch(pauseToggle(false));
            }
            store.dispatch(pauseToggle(false));
            store.dispatch(setReUpdateTimer(true));
            store.dispatch(setAgentStateDuration(0));
            store.dispatch(handleDispositionEnable(false))
            showSuccessNotification(`Pause Reason: ${temp.reason},TimeLimit: ${tempTime < 0 ? 0 : tempTime} Sec`)
            Logger.info(`Agent State Successfully changed to Pause. Reason: ${temp.reason},TimeLimit: ${tempTime < 0 ? 0 : tempTime} Seconds`)
            LocalStorageService.setItem("maxPauseTime", originalPauseDuration);
            store.dispatch(setAgentState(AGENT_STATE.NOT_READY));
            store.dispatch(loading(false));
            store.dispatch(setAgentStateDuration(Math.round((elapsedTime / 1000))))
            store.dispatch(setLogoutTimer(true));
            const startTime = Date.now();
            LocalStorageService.setItem("logoutStartTime", startTime);
            Logger.info('Agent State changed to Pause');
            store.dispatch(setIsComponentOnCall(false));
            store.dispatch(setIsCallAttended(false));
            store.dispatch(setIsCallIncomming(false));
            store.dispatch(setDispositionValues("clear"));
            if (store.getState().call.isCallEnded) {
                store.dispatch(callEndActions());
                store.dispatch(setWrapUpTime(0));
            }
        }
    } catch (error) {
        console.error("Error in handleToolbarPause:", error);
    }
}
function handleExceptionState() {
    let temp = {
        reason: "EXCEPTION",
        timeLimit: 0
    }
    store.dispatch(setPauseReason(temp));

}


function timeToSeconds(time) {
    const [hours, minutes, seconds] = time.split(':').map(num => parseInt(num));
    return hours * 3600 + minutes * 60 + seconds;
}

function getTimeDifference(timeInString) {
    const eventTime = (timeToSeconds(dayjs(timeInString, "hh:mm:ss").format("hh:mm:ss")));
    const currentTime = (timeToSeconds(dayjs(new Date()).format("hh:mm:ss")));
    return (currentTime - eventTime);
}

export function handleNotReadyTimeount() {
    const isSIPconnected = store.getState().toolbar.isSIPconnected;
    const isSIPEnabled = store.getState().toolbar.loginDetails.isSip;
    const isSIPconnecting = store.getState().toolbar.isSIPconnecting;
    let initialMaxPauseTiming = getParam('NOTREADY_TIMEOUT');
    if (initialMaxPauseTiming === "0" && !store.getState().timer.autoUpdateAgentState.altered) {
        store.dispatch(setAutoUpdateAgentState({ countDown: 0, altered: true }))
    }
    let coundown = Number(initialMaxPauseTiming)
    if (Number(initialMaxPauseTiming) > 0 && !store.getState().timer.autoUpdateAgentState.altered) {
        if (store.getState().timer.autoUpdateAgentState.countDown !== null && (store.getState().timer.autoUpdateAgentState.countDown !== -1)) {
            coundown = store.getState().timer.autoUpdateAgentState.countDown
        }
        if (!isSIPEnabled) {
            showWarningNotification(`Agent State will be Changed to Ready in ${coundown} seconds`);
        }
        if (isSIPEnabled && (isSIPconnected || isSIPconnecting)) {
            showWarningNotification(`Agent State will be Changed to Ready in ${coundown} seconds`);
        }
        store.dispatch(setAutoUpdateAgentState({ countDown: coundown, altered: false }))
        countdownTimer(coundown);
    }
}

export async function getTemplatesAndSaveReplies() {
    await getWhatsAppTemplates();
    await getSavedReplys();
}
export async function authDashboard() {
    try {
        const resp = await loginAdmin();
        store.dispatch(setAdminToken(resp.token));
        store.dispatch(setRefreshToken(resp.refreshToken));
        return true;
    } catch (error) {
        Logger.log(error);
        return false;
    }
}
export async function getSavedReplys(type) {
    try {
        let url = new URL(HttpService.getURL('whatsAppTemplates'));
        let baseDomain = `${url.protocol}//${url.host}`;
        const response = await fetch(`${baseDomain}/ca-admin-Api/CloudAgentAPI/templates?type=savedReplies`, {
            method: 'GET',
            headers: getDashBoardHeaders(),
        });
        const data = await response?.json();
        if (data.Status === "Success") {
            const allSavedReplies = data?.Data || [];
            const savedReplies = allSavedReplies.filter(reply => reply.type === type);
            store.dispatch(setWhatsAppSavedReplys(savedReplies));
        } else {
            store.dispatch(setWhatsAppSavedReplys([]));
        }
    } catch (e) {
        Logger.error('Failed to get Saved replies ', e);
        store.dispatch(loading(false));
        showErrorNotification('Failed to get Saved replies ');
    }
}
export const getWhatsAppTemplates = async () => {
    try {
        let url = new URL(HttpService.getURL('whatsAppTemplates'));
        url.searchParams.set("page", 0);
        url.searchParams.set("size", 1000);
        url.searchParams.set("type", "whatsapp");

        const response = await fetch(url, {
            method: 'GET',
            headers: getDashBoardHeaders(),
        });

        const data = await response?.json();

        if (Array.isArray(data?.data?.content)) {
            const rawT = data.data.content?.map((template) => {
                let parsedText = [];
                let bodyText = '';
                try {
                    if (template?.approved && template?.text) {
                        parsedText = JSON.parse(template.text);
                        const body = parsedText.find(item => item?.type === 'BODY');
                        if (body?.text) {
                            bodyText = body.text;
                        }
                    }
                } catch (err) {
                    console.error(`Error parsing template ${template.name}`, err);
                }

                return {
                    ...template,
                    parsedText,
                    bodyText
                };
            }).filter((template) => {
                const hasBody = template.parsedText?.some(item => item.type === 'BODY');
                const variables = template.variables || {};
                const isValid = Object.keys(variables)?.length === 0 ||
                    Object.keys(variables)?.every(key => key.startsWith("body_"));
                return hasBody && isValid;
            });

            store.dispatch(setWhatsAppTemplates(rawT));
            console.log("Filtered WhatsApp Templates:", rawT);
        }
    } catch (e) {
        console.log("Error while parsing WhatsApp templates", e);
    }
};

export async function logOutAgnet() {
    let mode = store.getState().toolbar.agent.mode;
    store.dispatch(loading(true));
    try {
        const resp = await agentService("tbAgentLogout", { params: mode.toUpperCase(), logoutBy: 'logoffByAgent', })
        let respKeys = Object.keys(resp);
        if (respKeys.includes('resp')) {
            if (resp.resp === "Success") {
                let showingToolbarInCrm = store?.getState()?.toolbar?.showingToolbarInCrm;
                window.parent.postMessage({ action: "logout", token: {} }, "*");
                aToolbar !== undefined && aToolbar.trigger("logout");
                store.dispatch(logout());
                clearSession();
                showSuccessNotification("Logout Successful");
                Logger.info("Logout successful");
                if (!showingToolbarInCrm) {
                    console.log("tbAgentLogout ->: showingToolbarInCrm",!showingToolbarInCrm)
                    window.location.href = '/login';
                }
                store.dispatch(logout());
                clearSession();
                showSuccessNotification("Logout Successful");
                Logger.info("Logout successful");
                if (showingToolbarInCrm) {
                    goToLogin();
                } else {
                    console.log("tbAgentLogout ->: showingToolbarInCrm",showingToolbarInCrm)
                    window.location.href = '/login';
                }
            }
        } else {
            Logger.error("Logout Un-successful, " + JSON.stringify(resp))
            showErrorNotification('Logout Un-successful');
        }
        store.dispatch(loading(false));
    } catch (e) {
        Logger.error('Unable to logout', e);
        store.dispatch(loading(false));
        showErrorNotification('Logout Un-successful');
    }
}

export async function endCurrentCall(type = "tbDropHold") {
    const dispatch = store.dispatch;
    const dispositionValues = store.getState().toolbar.dispositionValues;
    const DONT_CLOSE_SPOP = store.getState().toolbar.params.DONT_CLOSE_SPOP;
    const callData = store.getState().call.callDetails;
    dispatch(setChatOnCall(false));
    let dispositionValuesobj = structuredClone(dispositionValues);
    dispatch(setDispositionValues(dispositionValuesobj));
    dispatch(handleDispositionEnable(false));
    if (callData.dispositionType === "-1") {
        if (DONT_CLOSE_SPOP === 'false') {
            dispatch(removeTab('Pop CRM'));
            dispatch(setScreenpopURL(null));
            removeScreenpopFromStorage('Pop CRM');
        }
        dispatch(removeTab('Script'));
        dispatch(setDispositionValues({
            rescheduleDateTime: null,
            rescheduleComment: null,
            reason: null,
            pauseReasonState: false,
            callBackTimezoneSelected: null,
        }));
        dispatch(setCurrentLocationTimeAndRescheduleTime({
            currentLocationTime: null,
            rescheduleDateTime: null
        }));
        localStorage.removeItem("rescheduleDateAndTime");
        localStorage.removeItem("CancelDispositionScreen");
        LocalStorageService.removeItem('dispDateAndTime');
        LocalStorageService.removeItem('dispComment');
        LocalStorageService.removeItem('dispPauseState');
        LocalStorageService.removeItem('dispPauseReason');
        LocalStorageService.removeItem('dispZone');
        LocalStorageService.removeItem('dispCurrentLocationTime');
        LocalStorageService.removeItem('forceRedialAfterDispose');
        dispatch(setDispositionReqbody(null))
        dispatch(handleMultiDisposition({
            disp1: null,
            disp1SelectedValue: null,
            disp2: null,
            disp2SelectedValue: null,
            disp3: null,
            disp3SelectedValue: null,
            disp4: null,
            disp4SelectedValue: null,
            disp5: null,
            disp5SelectedValue: null,
        }))
    }
    dispatch(loading(true));
    LocalStorageService.setItem("CancelDispositionScreen", false)
    dropAgentFromCall(type, false);
}

export function dropAgentFromCall(type = "tbDropHold", forceReleaseByAgent = false) {
    const dispatch = store.dispatch;
    const { callDetails: callData, isCallAttended } = store.getState().call;

    try {
        agentService('tbDropHold', {
            customerNumber: callData.callerId,
            monitorUcid: callData.monitorUcid,
            ucid: callData.ucid,
            did: callData.did,
        }).then((resp) => {
            if (resp.status === "Error" && resp.message && resp.message.trim().toLowerCase().includes("call not found")) {
                showErrorNotification("Call not found, trying to end call explicitly");
                explicitHangup();// if success then will get agent release event
                if (isCallAttended && forceReleaseByAgent) {
                    const dispatch = store.dispatch;
                    dispatch(setIsComponentOnCall(false));
                    dispatch(setIsCallAttended(false));
                    dispatch(setIsCallIncomming(false));
                    dispatch(setIsCallEnded(false));
                    dispatch(callEndActions());
                }
                return;
            }
            if (resp.status === "Success") {
                showSuccessNotification("Call Ended Successfully")
                if (type === "agentReleaseWOACW" && isCallAttended) {
                    handleDropCall({ type: "agentReleaseWOACW", ucid: callData.ucid, })
                }
                Logger.info(resp.message);
                dispatch(minimizeCall(false))
            } else {
                Logger.error(resp.message)
                showErrorNotification(resp.message)
            }
        }
        ).catch(e => {
            Logger.error(e);
            showErrorNotification("Unable to End Call");
            dispatch(loading(false))
        }).finally(() => {
            dispatch(loading(false));
        });
    } catch (e) {
        Logger.error(e);
        showErrorNotification("Unable to End Call")
        dispatch(loading(false));
    }
}

export const explicitHangup = async () => {
    Logger.info("Initiating explicit hangup");
    const dispatch = store.dispatch;
    const { callDetails: callData } = store.getState().call;
    const tbCallHangupExplicitParams = {
        ucid: (callData.ucid),
        monitorUcid: (callData.monitorUcid),
        campaignId: (callData.campaignId),
        did: (callData.did),
        callType: callData.callType,
        agentId: getAgentData().agentInfo.agentId,
    }
    console.log("dropAgentFromCall ~ tbCallHangupExplicitParams:", tbCallHangupExplicitParams)

    try {
        const resp = await agentService('tbCallHangupExplicit', tbCallHangupExplicitParams);
        console.log("dropAgentFromCall ~ resp:", resp)
        if (resp.status === "fail") {
            handleReconnect(store.getState().toolbar.agent.mode);
        }
        dispatch(loading(false))
    }
    catch (e) {
        Logger.error(e);
        showErrorNotification("Unable to End Call");
        dispatch(loading(false))
    }

}